import type { Order } from '@/mocks/orders';
import { statusLabels, statusColors } from '@/mocks/orders';

interface OrderRowProps {
  order: Order;
  showActions?: boolean;
}

export default function OrderRow({ order, showActions = true }: OrderRowProps) {
  const whatsappUrl = `https://wa.me/${order.phone}`;

  return (
    <div className="flex items-center gap-3 py-3 px-4 hover:bg-stone-50/70 rounded-lg transition-colors group">
      {/* Status dot */}
      <div className="flex-shrink-0">
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${statusColors[order.status]}`}>
          {statusLabels[order.status]}
        </span>
      </div>

      {/* Customer & order info */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-semibold text-stone-800 whitespace-nowrap">{order.customerName}</span>
          <span className="text-xs text-stone-400">·</span>
          <span className="text-xs text-stone-500 whitespace-nowrap">{order.id}</span>
          {order.isUrgent && (
            <span className="text-xs bg-status-red/10 text-status-red px-1.5 py-0.5 rounded font-medium pulse-warning">ACİL</span>
          )}
          {order.isLate && (
            <span className="text-xs bg-status-red/10 text-status-red px-1.5 py-0.5 rounded font-medium">GECİKMİŞ</span>
          )}
        </div>
        <p className="text-xs text-stone-400 mt-0.5 truncate">{order.productName} · {order.phone.replace('90', '0')} · {order.city}</p>
      </div>

      {/* Payment status */}
      <div className="hidden md:block flex-shrink-0">
        {order.paymentType === 'kapida_odeme' && order.paymentStatus === 'bekleniyor' ? (
          <span className="text-xs text-status-orange font-medium whitespace-nowrap">
            {order.amount.toLocaleString('tr-TR')} ₺ tahsilat bekliyor
          </span>
        ) : order.paymentStatus === 'tahsil_edildi' ? (
          <span className="text-xs text-status-green font-medium whitespace-nowrap">₺ Tahsil Edildi</span>
        ) : (
          <span className="text-xs text-stone-400 whitespace-nowrap">{order.amount.toLocaleString('tr-TR')} ₺</span>
        )}
      </div>

      {/* Actions */}
      {showActions && (
        <div className="flex items-center gap-1 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-8 h-8 flex items-center justify-center rounded-lg bg-green-50 text-green-600 hover:bg-green-100 transition-colors"
            title="WhatsApp"
          >
            <i className="ri-whatsapp-line text-base" />
          </a>
          <button
            className="w-8 h-8 flex items-center justify-center rounded-lg bg-stone-100 text-stone-500 hover:bg-stone-200 transition-colors"
            title="Detay"
          >
            <i className="ri-arrow-right-s-line text-base" />
          </button>
        </div>
      )}
    </div>
  );
}